import cloneDeep from 'lodash/cloneDeep';
import { Signal } from 'typed-signals';
import type { BlockerModel, ScoreBlockerState, BlockerType } from '../../types';
import { generateId } from '../../../../utils/generateId';

export class ScoreBlockerModel implements BlockerModel {
  public readonly underTile = false;

  public readonly id = generateId('score');

  public readonly destructible = true;

  private unlocked = false;

  public readonly requestRemoval = new Signal();

  public readonly onProgressChanged = new Signal<(score: number, target: number) => void>();

  private readonly state: ScoreBlockerState;

  constructor(state: ScoreBlockerState) {
    this.state = cloneDeep(state);
  }

  public getScore(): number {
    return this.state.score;
  }

  public setScore(score: number): void {
    this.state.score = score;
  }

  public isUnlocked(): boolean {
    return this.unlocked;
  }

  public onScoreChanged(score: number): void {
    this.unlocked = score >= this.state.score;

    if (!this.unlocked) {
      this.onProgressChanged.emit(score, this.state.score);
      return;
    }

    this.requestRemoval.emit();
  }

  public exportState(): ScoreBlockerState {
    return this.state;
  }

  public getType(): BlockerType {
    return this.state.type;
  }
}
